export const ageLevels = [
  { label: "Under 4", value: "under 4" },
  { label: "Under 5", value: "under-5" },
  { label: "Under 6", value: "under-6" },
  { label: "Under 7", value: "under-7" },
  { label: "Under 8", value: "under-8" },
  { label: "Under 9", value: "under-9" },
  { label: "Under 10", value: "under-10" },
  { label: "Under 11", value: "under-11" },
  { label: "Under 12", value: "under-12" },
  { label: "Under 13", value: "under-13" },
  { label: "Under 14", value: "under-14" },
  { label: "Under 15", value: "under-15" },
  { label: "Under 16", value: "under-16" },
  { label: "Under 17", value: "under-17" },
  { label: "Under 18", value: "under-18" },
  { label: "Seniors", value: "seniors" },
  { label: "Masters", value: "masters" },
  { label: "All Ages", value: "all-ages" },
];
export const statusMapper: {
  id: string;
  label: string;
  shortLabel?: string;
}[] = [
  {
    id: "live",
    label: "LIVE",
  },
  {
    id: "washout",
    label: "WASHOUT",
    shortLabel: "WASH",
  },
  {
    id: "postponed",
    label: "POSTPONED",
    shortLabel: "POST",
  },
  {
    id: "forfeit",
    label: "FORFEIT",
  },
  {
    id: "tba",
    label: "TBA",
  },
  {
    id: "fulltime",
    label: "FULLTIME",
    shortLabel: "F/T",
  },
  {
    id: "pre-game",
    label: "PREGAME",
  },
  {
    id: "Final",
    label: "FINAL",
  },
  {
    id: "final",
    label: "FINAL",
  },
  {
    id: "in-progress",
    label: "IN-PROGRESS",
  },
];

export const tabOptions = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "team",
    label: "Team",
  },
  {
    value: "club",
    label: "Club",
  },
  {
    value: "association",
    label: "Association",
  },
  {
    value: "competition",
    label: "Competition",
  },
];

export const headerEntityBlock = [
  {
    entities: [
      {
        href: "https://www.nswrl.com.au/?_ga=2.201679761.1402643463.1708348693-1484650716.1708348693",
        name: "NSWRL",
      },
      {
        href: "https://www.qrl.com.au/?_ga=2.201679761.1402643463.1708348693-1484650716.1708348693",
        name: "QRL",
      },
      {
        href: "https://www.nrlvic.com/",
        name: "VIC",
      },
      {
        href: "https://nrlwa.com.au/",
        name: "WA",
      },
      {
        href: "https://www.nrlnt.com.au/",
        name: "NT",
      },
      {
        href: "https://www.nrlsa.com.au/",
        name: "SA",
      },
      {
        href: "https://www.nrlvic.com/",
        name: "TAS",
      },
    ],
    header: "state sites",
  },
  {
    entities: [
      {
        href: "https://www.nrl.com.au/",
        image:
          "data:image/svg+xml,%3csvg%20clip-rule='evenodd'%20fill-rule='evenodd'%20stroke-linejoin='round'%20stroke-miterlimit='1.41421'%20viewBox='0%200%20100%20100'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='m50%205.995c-18.356%200-35.25%202.25-35.25%202.25v56.255c0%207.488%202.992%2012.87%208.624%2016.12l26.626%2015.375%2026.626-15.375c5.632-3.25%208.624-8.635%208.624-16.12v-56.255s-16.895-2.25-35.25-2.25zm33%2058.505-.002.19v.185c0%20.54-.024.817-.059%201.322-.408%205.666-2.904%209.857-7.438%2012.474l-25.501%2014.726-25.501-14.725c-4.595-2.652-7.038-6.733-7.439-12.441l-.007-.005c-.034-.523-.058-.799-.058-1.351v-8.873l.005.003v-6.466c-.003-.128-.005-.257-.005-.385v-8.873l.005.003v-30.047s16-1.992%2033-1.992%2033%201.992%2033%201.992zm-63.515%203.131c.653%204.102%202.677%207.094%206.139%209.092l24.376%2014.076%2024.376-14.076c3.463-1.999%205.488-4.992%206.139-9.096l-30.515%2017.619zm-.235-15.858v5.531l30.75%2017.751%2030.75-17.755v-5.531l-30.75%2017.755zm0-39.524v29.333l30.75%2017.751%2030.75-17.754v-29.33s-15.25-1.754-30.75-1.754c-16%200-30.75%201.754-30.75%201.754zm11.657%205.746h-4.407v18.249h4.441v-10.1h.083l6.405%2010.1h4.371v-14.388h9.874c1.828.001%202.716.817%202.716%202.496%200%201.539-.918%202.458-2.458%202.458h-2.791v-2.877h-4.674v12.311h4.674v-5.46h2.266l4.428%205.46h5.781l-5.459-6.558c1.788-1.09%202.761-3.02%202.761-5.445%200-3.894-2.651-6.246-6.912-6.246h-14.756v10.136h-.099zm44.343%2018.249v-4.048h-9.289v-14.201h-4.711v14.747l2.915%203.502z'%20fill='%2300cf5d'/%3e%3c/svg%3e",
        name: "NRL",
      },
      {
        href: "https://www.tfa.com.au/",
        name: "TFA",
      },
    ],
    header: "nrl network sites",
  },
];

export const footerLinks = [
  {
    href: "https://www.playrugbyleague.com/contact-us/",
    name: "Contact us",
  },
  {
    href: "https://www.playrugbyleague.com/join-our-team/",
    name: "Join Our Team",
  },
  {
    href: "https://www.playrugbyleague.com/laws-of-the-game-community/",
    name: "Laws of the Game",
  },
  {
    href: "https://www.playrugbyleague.com/policies/",
    name: "Policies",
  },
  {
    href: "https://www.playrugbyleague.com/terms-and-conditions/",
    name: "Terms & Conditions",
  },
  {
    href: "https://www.playrugbyleague.com/member-protection-information-officers/",
    name: "Member Protection Information Officer",
  },
];

export const socialLinksData = [
  {
    href: "https://www.facebook.com/nrl/",
    image:
      "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20xml:space='preserve'%20width='100'%20height='100'%20fill='white'%20stroke='white'%20fill-rule='evenodd'%20stroke-linejoin='round'%20stroke-miterlimit='1.414'%20clip-rule='evenodd'%20viewBox='0%200%20100%20100'%3e%3cpath%20d='M58.473%20100V49.994h15.196l2.013-17.232H58.473l.026-8.625c0-4.495.47-6.903%207.576-6.903h9.5V0H60.377c-18.255%200-24.68%208.36-24.68%2022.418v10.346H24.318v17.232h11.379V100h22.776Z'/%3e%3c/svg%3e",
    name: "Facebook",
  },
  {
    href: "https://intagram.com/NRL",
    image:
      "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20xml:space='preserve'%20width='100'%20height='100'%20fill='white'%20stroke='white'%20fill-rule='evenodd'%20stroke-linejoin='round'%20stroke-miterlimit='1.414'%20clip-rule='evenodd'%20viewBox='0%200%20100%20100'%3e%3cpath%20d='M50%204c-12.493%200-14.059.053-18.966.277-4.896.223-8.24%201.001-11.166%202.138-3.025%201.176-5.59%202.748-8.147%205.306-2.558%202.557-4.131%205.122-5.306%208.147-1.137%202.926-1.915%206.27-2.138%2011.166C4.053%2035.941%204%2037.507%204%2050c0%2012.493.053%2014.059.277%2018.966.223%204.896%201.001%208.24%202.138%2011.166%201.175%203.025%202.748%205.59%205.306%208.147%202.557%202.558%205.122%204.131%208.147%205.306%202.926%201.137%206.27%201.915%2011.166%202.138C35.941%2095.947%2037.507%2096%2050%2096c12.493%200%2014.059-.053%2018.966-.277%204.896-.223%208.24-1.001%2011.166-2.138%203.025-1.175%205.59-2.748%208.147-5.306%202.558-2.557%204.131-5.122%205.306-8.147%201.137-2.926%201.915-6.27%202.138-11.166C95.947%2064.059%2096%2062.493%2096%2050c0-12.493-.053-14.059-.277-18.966-.223-4.896-1.001-8.24-2.138-11.166-1.175-3.025-2.748-5.59-5.306-8.147-2.557-2.558-5.122-4.13-8.147-5.306-2.926-1.137-6.27-1.915-11.166-2.138C64.059%204.053%2062.493%204%2050%204Zm0%208.288c12.282%200%2013.737.047%2018.588.269%204.485.204%206.921.954%208.541%201.583%202.148.835%203.68%201.832%205.29%203.441%201.609%201.61%202.606%203.143%203.441%205.29.63%201.62%201.379%204.056%201.583%208.541.222%204.851.269%206.306.269%2018.588s-.047%2013.737-.269%2018.588c-.204%204.485-.953%206.921-1.583%208.541-.835%202.148-1.832%203.68-3.441%205.29-1.61%201.609-3.142%202.606-5.29%203.441-1.62.63-4.056%201.379-8.541%201.583-4.85.222-6.305.269-18.588.269-12.283%200-13.738-.047-18.588-.269-4.485-.204-6.921-.953-8.541-1.583-2.148-.835-3.68-1.832-5.29-3.441-1.609-1.61-2.606-3.142-3.441-5.29-.63-1.62-1.379-4.056-1.584-8.541-.221-4.851-.268-6.306-.268-18.588s.047-13.737.268-18.588c.205-4.485.954-6.921%201.584-8.541.835-2.147%201.832-3.68%203.441-5.29%201.61-1.609%203.142-2.606%205.29-3.441%201.62-.629%204.056-1.379%208.541-1.583%204.851-.222%206.306-.269%2018.588-.269Zm0%2014.09c-13.046%200-23.622%2010.576-23.622%2023.622S36.954%2073.622%2050%2073.622%2073.622%2063.046%2073.622%2050%2063.046%2026.378%2050%2026.378Zm0%2038.955c-8.468%200-15.333-6.865-15.333-15.333S41.532%2034.667%2050%2034.667%2065.333%2041.532%2065.333%2050%2058.468%2065.333%2050%2065.333Zm30.075-39.888a5.52%205.52%200%201%201-11.04%200%205.52%205.52%200%201%201%2011.04%200Z'/%3e%3c/svg%3e",
    name: "Instagram",
  },
  {
    href: "https://www.tiktok.com/nrl/",
    image:
      "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20xml:space='preserve'%20width='100'%20height='100'%20fill-rule='evenodd'%20stroke-linejoin='round'%20fill='white'%20stroke='white'%20stroke-miterlimit='2'%20clip-rule='evenodd'%20viewBox='0%200%20100%20100'%3e%3cpath%20d='M70.09%200H53.24v68.119c0%208.112-6.481%2014.781-14.55%2014.781-8.062%200-14.55-6.669-14.55-14.781%200-7.975%206.344-14.494%2014.119-14.788v-17.1C21.115%2036.52%207.29%2050.581%207.29%2068.12%207.29%2085.8%2021.41%20100%2038.834%20100c17.431%200%2031.544-14.35%2031.544-31.881V33.188a39.044%2039.044%200%200%200%2022.331%207.537v-17.1C80.034%2023.187%2070.09%2012.756%2070.09%200Z'/%3e%3c/svg%3e",
    name: "TikTok",
  },
  {
    href: "https://twitter.com/NRL",
    image:
      "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20xml:space='preserve'%20width='100'%20height='100'%20fill-rule='evenodd'%20fill='white'%20stroke='white'%20stroke-linejoin='round'%20stroke-miterlimit='1.414'%20clip-rule='evenodd'%20viewBox='0%200%20100%20100'%3e%3cpath%20d='M0%2080.35a43.19%2043.19%200%200%200%204.894.277c9.612%200%2018.458-3.169%2025.48-8.484-8.978-.16-16.555-5.891-19.165-13.765a21.223%2021.223%200%200%200%209.265-.339c-9.386-1.821-16.457-9.832-16.457-19.435l.001-.249a20.98%2020.98%200%200%200%209.293%202.479c-5.505-3.554-9.127-9.62-9.127-16.497a19.22%2019.22%200%200%201%202.778-9.964C17.08%2026.364%2032.198%2034.255%2049.249%2035.081a19.23%2019.23%200%200%201-.532-4.516c0-10.946%209.186-19.82%2020.517-19.82%205.901%200%2011.233%202.408%2014.975%206.26a41.992%2041.992%200%200%200%2013.028-4.81c-1.532%204.628-4.784%208.512-9.021%2010.965A42.115%2042.115%200%200%200%20100%2020.039a40.939%2040.939%200%200%201-10.237%2010.26c.039.85.059%201.705.059%202.564%200%2026.191-20.636%2056.392-58.372%2056.392-11.586%200-22.371-3.281-31.45-8.905Z'/%3e%3c/svg%3e",
    name: "Twitter",
  },
];

export const headerSubMenuData = {
  competitions: [
    {
      name: "club rugby league",
      url: "club-rugby-league",
    },
    {
      name: "rewards",
      url: "rewards",
    },
    {
      name: "wheelchair rugby league",
      url: "wheelchair-rugby-league",
    },
    {
      name: "league stars",
      url: "league-stars",
    },
    {
      name: "little league stars",
      url: "little-league-stars",
    },
    {
      name: "school holiday clinics",
      url: "school-holiday-clinics",
    },
    {
      name: "child safety",
      url: "child-safety",
    },
  ],
  play: [
    {
      name: "club rugby league",
      url: "club-rugby-league",
    },
    {
      name: "rewards",
      url: "rewards",
    },
    {
      name: "wheelchair rugby league",
      url: "wheelchair-rugby-league",
    },
    {
      name: "league stars",
      url: "league-stars",
    },
    {
      name: "little league stars",
      url: "little-league-stars",
    },
    {
      name: "school holiday clinics",
      url: "school-holiday-clinics",
    },
    {
      name: "child safety",
      url: "child-safety",
    },
  ],
};

export const headerMenuData = [
  {
    name: "play",
    url: "play",
  },
  {
    name: "assist",
    url: "assist",
  },
  {
    name: "learn",
    url: "learn",
  },
  {
    name: "competitions",
  },
  {
    name: "coach",
    url: "coach",
  },
  {
    name: "safety",
    url: "safety",
  },
  {
    name: "shop",
    url: "shop",
  },
];

export const defaultLocations = [1516, 41, 1333, 39, 1638, 40, 37, 36, 7386];
export const defaultTfaLocations = [
  3409, 361, 362, 366, 1504, 363, 364, 360, 365,
];

export const prlProdDefaultLocations = [1516, 41, 1333, 39, 1638, 40, 37, 36, 7386, 65622968, 319219];
export const tfaProdDefaultLocations = [
  3409, 361, 362, 366, 1504, 363, 364, 360, 365,
];

export const playerMovementsIgnorableItems = {
  15: "Sin Bin Return To Field",
};

export const ScoringEventsFractions = {
  conversion: [1, 2],
  penalty: [67, 68],
};

export const NonPlayerRolesMapper = {
  coach: "Coach",
  "assistant-coach": "Assistant Coach",
  manager: "Manager",
  "trainer-4": "Level 2 Trainer",
  "trainer-3": "Level 1 Trainer",
  "trainer-2": "League First Aid",
  "trainer-1": "LeagueSafe",
  "chief-cmo": "Chief CMO",
  "assistant-cmo": "Assistant CMO",
};
